import React from "react";
import "./FeaturedCoursesSection.css";
import { useHistory } from "react-router-dom";

const courses = [
  {
    id: "19786ca8-a130-4eda-aac8-2c009d8dad8c",
    title: "AI Tools Mastery and ChatGPT",
    level: "Beginner",
    subtitle: "Master the most impactful AI tools and ChatGPT to boost your creativity and productivity.",
    author: "Gaurav Gupta",
    rating: 4.9,
    learners: "3K",
    duration: "24 hours",
    price: "$49",
    image: "https://nxnearby-assets.s3.amazonaws.com/media/uploads/courses/44/Course_image/A.png",
  },
  {
    id: "3e0189f4-32ea-4afd-83a0-9f85e86dd37e",
    title: "Python for AI and Data Science",
    level: "Beginner",
    subtitle: "A complete Python learning path from basics to AI and data science applications.",
    author: "Gaurav Gupta",
    rating: 4.8,
    learners: "3K",
    duration: "24 hours",
    price: "$49",
    image: "https://nxnearby-assets.s3.amazonaws.com/media/uploads/courses/44/Course_image/B.jpg",
  },
  {
    id: "f8e1343e-cc37-4f44-8a75-ec3fd5b4bcac",
    title: "AI Career Transition Bootcamp",
    level: "Beginner",
    subtitle: "Switch to an AI-driven career through hands-on, guided learning.",
    author: "Gaurav Gupta",
    rating: 4.9,
    learners: "2K",
    duration: "24 hours",
    price: "$49",
    image: "https://nxnearby-assets.s3.amazonaws.com/media/uploads/courses/44/Course_image/C.jpg",
  },
  {
    id: "d66cbd95-3961-4668-8ac6-2bdcbced8eb8",
    title: "AI & Python for Young Innovators",
    level: "Kids",
    subtitle: "A fun way to introduce AI and Python to young creators.",
    author: "Gaurav Gupta",
    rating: 4.7,
    learners: "2K",
    duration: "24 hours",
    price: "$49",
    image: "https://nxnearby-assets.s3.amazonaws.com/media/uploads/courses/44/Course_image/D.jpg",
  },
  {
    id: "3e505a67-22cc-4f29-aed5-c9dedfe41c57",
    title: "Embrace Developer Productivity",
    level: "Intermediate",
    subtitle: "Boost your coding efficiency and creativity using AI tools.",
    author: "Gaurav Gupta",
    rating: 4.2,
    learners: "3K",
    duration: "18 hours",
    price: "$59",
    image: "https://nxnearby-assets.s3.amazonaws.com/media/uploads/courses/44/Course_image/5th_one.png",
  },
];

export default function FeaturedCoursesSection() {
  const history = useHistory();

  const handleEnrollClick = (courseId) => {
    const token = localStorage.getItem("token");

    if (token) {
      history.push(`/course/view/${courseId}`);
    } else {
      history.push({
        pathname: "/signup",
        state: { detail: "INDIVIDUAL" },
      });
    }
  };

  return (
    <section className="featured-courses">
      <header className="featured-header">
        <h2>
          Featured <span>Courses</span>
        </h2>
        <p>Handpicked courses to accelerate your career</p>
      </header>

      <div className="course-row">
        {courses.map((course) => (
          <article className="course-card" key={course.id}>
            <div className="course-image">
              <span className="badge">Trending</span>
              <img src={course.image} alt={course.title} />
              <span className="course-rating">
                <span>★</span> {course.rating}
              </span>
            </div>

            <div className="course-body">
              <span className="level">{course.level}</span>

              <h3>{course.title}</h3>
              <p className="author">by {course.author}</p>

              <div className="course-meta">
                <span><img className="learners-icon" src="/Image/CourseMonetisation/Learners.svg" alt="" /> {course.learners}</span>
                <span>
                  <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                        fill="#4A5565"
                    />
                    <path
                        d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2343 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.5459 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z"
                        fill="#4A5565"
                    />
                  </svg> {course.duration}
                </span>
              </div>

              <div className="course-footer">
                <span className="price">{course.price}</span>
                <button onClick={() => handleEnrollClick(course.id)}>
                  Enroll
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
